import { useEffect, useMemo } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { useLocation } from "react-router";

import { useInIframe } from "./useInIframe";

export const useUrlCommunicatorV2 = () => {
  const isInIframe = useInIframe();
  const breadcrumbs = useSelector((state: RootStateOrAny) => state.app.breadcrumbs);
  const location = useLocation();
  const breadcrumbsFromLocalStorage = localStorage.getItem("breadcrumbs_v2");
  const locationFromLocalStorage = localStorage.getItem("location_v2");

  const memoizedLocation = useMemo(
    () => `${location.pathname}${location.search}${location.hash}`,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location],
  );

  const isSameBreadcrumbs = useMemo(() => {
    return JSON.stringify(breadcrumbs) === breadcrumbsFromLocalStorage;
  }, [breadcrumbs, breadcrumbsFromLocalStorage]);

  const isSameLocation = useMemo(() => {
    return memoizedLocation === locationFromLocalStorage;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, locationFromLocalStorage]);

  const REACT_APP_PARENT_ORIGIN = process.env.REACT_APP_PARENT_ORIGIN;

  const sendBreadcrumbsToParent = () => {
    if (!isInIframe) return;
    if (breadcrumbs.length === 0) return;
    if (isSameBreadcrumbs) return;
    const message = {
      type: "BREADCRUMBS_UPDATE",
      breadcrumbs,
    };
    window.parent.postMessage(JSON.stringify(message), REACT_APP_PARENT_ORIGIN || "*");
    localStorage.setItem("breadcrumbs_v2", JSON.stringify(breadcrumbs));
  };

  const sendUrlToParent = () => {
    if (!isInIframe) return;
    if (isSameLocation) return;
    const message = {
      type: "URL_UPDATE",
      url: memoizedLocation,
    };
    window.parent.postMessage(JSON.stringify(message), REACT_APP_PARENT_ORIGIN || "*");
    localStorage.setItem("location_v2", memoizedLocation);
  };

  useEffect(() => {
    sendBreadcrumbsToParent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breadcrumbs]);

  useEffect(() => {
    sendUrlToParent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return { sendUrlToParent };
};
